import { zodResolver } from '@hookform/resolvers/zod';
import { Grid } from '@mui/material';
import { useUuid } from '@procureai/ui-mui';
import { forwardRef, useCallback } from 'react';
import { DeepPartial, FormProvider, useForm } from 'react-hook-form';

import {
  negotiationCaseCreateFormDataDefault as defaultValues,
  NegotiationCaseCreateFormData,
  negotiationCaseCreateFormDataSchema as schema,
} from '../../common/common.schema';
import { NegotiationCaseCreateWizardState } from '../NegotiationCaseCreateWizard/NegotiationCaseCreateWizard.schema';
import { NegotiationTermsForm } from '~/components/NegotiationTermsForm/NegotiationTermsForm';
import { useWizardFormHandle } from '~/components/WizardState/hooks/useWizardStateHandle/useWizardStateHandle';
import { WizardRef } from '~/components/WizardState/WizardState';
import { SupplierContactForm } from '~/modules/NegotiationSupplierContactWidget/components/SupplierContactForm/SupplierContactForm';

export const NegotiationCaseStep = forwardRef<WizardRef, any>((_props, ref) => {
  const form = useForm<NegotiationCaseCreateFormData>({
    mode: 'all',
    resolver: zodResolver(schema),
    defaultValues,
  });
  const formId = useUuid();

  const toWizardState = useCallback(
    (state: NegotiationCaseCreateFormData): DeepPartial<NegotiationCaseCreateWizardState> => {
      const parsedData = schema.parse(state);
      return {
        supplier: parsedData.supplier,
        terms: {
          ...parsedData,
        },
      };
    },
    [],
  );

  useWizardFormHandle<NegotiationCaseCreateFormData, NegotiationCaseCreateWizardState>({
    form,
    toWizardState,
    createInitialFormState: (state) => ({
      ...state.terms,
      supplier: state.supplier,
    }),
    ref,
  });

  return (
    <FormProvider {...form}>
      <form id={formId} autoComplete="off" noValidate>
        <Grid
          container
          spacing={6}
          columns={2}
          sx={{
            paddingTop: 2,
          }}
        >
          <Grid size={1}>
            <SupplierContactForm />
          </Grid>
          <Grid size={1}>
            <NegotiationTermsForm />
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  );
});
